<template>
  <div v-if="auth_user.is_super_admin">
    <div v-if="unused_contacts.length">
      <label>FreshSales Contact</label>
      <multiselect v-model="selected_contact"
                   :options="unused_contacts"
                   label="display_name"
                   track-by="id"
                   :allow-empty="false"
                   placeholder="Select FreshSales Contact" />
      <span class="kt-form__help">
        <button type="button" class="btn btn-ss-link p-0 m-0 d-inline align-baseline" @click.prevent="getUnusedContacts(true)">Refresh</button>
      </span>
      <a v-if="selected_contact" href="javascript:;"
         class="kt-link"
         @click="updateProviderId">
        <span v-if="contact">Update</span>
        <span v-else>Save</span>
      </a>
    </div>

    <div v-if="contact_info">
      <table class="table table-striped mt-2">
        <thead>
          <tr>
            <th colspan="2">
              FreshSales Data
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Country</td>
            <td>{{ contact_info.country }}</td>
          </tr>
          <tr>
            <td>Email</td>
            <td>{{ contact_info.email }}</td>
          </tr>
          <tr>
            <td>Job Title</td>
            <td>{{ contact_info.job_title }}</td>
          </tr>
          <tr>
            <td>Numbers</td>
            <td>
              <span v-if="contact_info.mobile_number">Mobile : {{ contact_info.mobile_number }}<br></span>
              <span v-if="contact_info.work_number">Work : {{ contact_info.work_number }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <a :href="`https://sharpstream.freshsales.io/contacts/${contact_info.id}`" target="_blank" class="btn btn-sm btn-ss">View in FreshSales</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user: window.user,
      auth_user: window.auth_user,
      contact: null,
      unused_contacts: [],
      selected_contact: null,
    };
  },
  computed: {
    contact_info() {
      if (this.selected_contact) {
        return this.selected_contact;
      }
      if (this.contact) {
        return this.contact;
      }

      return null;
    },
  },
  mounted() {
    if (this.auth_user.is_super_admin) {
      this.setupContactInfo();
    }
  },
  methods: {
    async setupContactInfo() {
      await this.getCurrentContact();
      await this.getUnusedContacts();

      if (this.contact) {
        const vm = this;
        const matching_contact = _.find(this.unused_contacts, contact => contact.id == vm.contact.id);

        this.unused_contacts.push(this.contact);
        this.selected_contact = matching_contact;
      }
    },
    async getCurrentContact() {
      if (!this.user.provider_id) {
        return;
      }
      const response = await axios.get('/api/v1/admin/fresh-sales/contact-by-id', {
        params: { provider_id: this.user.provider_id },
      });
      if (response) {
        this.contact = response.data.data.contact;
      }
    },
    async getUnusedContacts(fresh = false) {
      const response = await axios.get('/api/v1/admin/fresh-sales/unused-contacts', {
        params: { fresh: fresh },
      });
      if (response) {
        this.unused_contacts = response.data.data;
      }
    },
    async updateProviderId() {
      try {
        const response = await axios.put(`/api/v1/user/${this.user.uuid}`, {
          provider_id: this.selected_contact.id,
        });
        if (response) {
          toastr.success("FreshSales Contact for User Updated");
        }
      } catch (error) {
        window.handleAxiosError(error);
      }
    },
  },
};
</script>
